import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const CSVParserNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const operation = data.config?.operation || 'parse';
  const delimiter = data.config?.delimiter || ',';

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-teal-400 to-teal-500 border-2 transition-all duration-200 ${
      selected ? 'border-teal-600 shadow-xl scale-105' : 'border-teal-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <DocumentTextIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-teal-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* Operation display */}
          <div className="flex items-center mt-1 space-x-2">
            <span className="text-xs text-teal-100">
              {operation === 'parse' ? '📊 CSV → JSON' : '📄 JSON → CSV'}
            </span>
            {delimiter !== ',' && (
              <span className="text-xs text-teal-100">
                | {delimiter}
              </span>
            )}
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution result */}
      {data.executionData?.rows && (
        <div className="mt-2 text-xs text-teal-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <strong>Sorok:</strong> {data.executionData.rows} db
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-teal-600 border-2 border-white"
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-teal-600 border-2 border-white"
      />
    </div>
  );
};

export default CSVParserNode;
